declare global
{
    interface Date
    {
        ToDate(): Date;
        IsToday(): boolean;
        Time(): Date;
    }
 


}

Date.prototype.ToDate = function (): Date
{
    return new Date(this.getFullYear(), this.getMonth(), this.getDate());
}

Date.prototype.IsToday = function (): boolean
{
    return this.ToDate().valueOf() == new Date().ToDate().valueOf();
}


Date.prototype.Time = function (): Date
{
    return new Date(1900, 1, 1, this.getHours(), this.getMinutes(), this.getSeconds());
}





export { }